import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as EmailIcon } from "../../../../../assets/images/People/Customers/email.svg";
import { ReactComponent as PhoneIcon } from "../../../../../assets/images/People/Customers/phone.svg";
import { ReactComponent as CompanyIcon } from "../../../../../assets/images/People/Customers/company.svg";
import { ReactComponent as ConversationsIcon } from "../../../../../assets/images/People/Customers/conversations.svg";
import { ReactComponent as LocationIcon } from "../../../../../assets/images/People/Customers/location.svg";
import { ReactComponent as TimezoneIcon } from "../../../../../assets/images/People/Customers/timezone.svg";
import { ReactComponent as StatusIcon } from "../../../../../assets/images/People/Customers/status.svg";
import { ReactComponent as LastSeenIcon } from "../../../../../assets/images/People/Customers/last-seen.svg";
import CustomerDetailInfoField from "./CustomerDetailInfoField";
import StatusChip from "../../StatusChip";

const sectionCardSx = {
  width: "100%",
  maxWidth: 632,
  minHeight: 344,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  p: 3,
  pt: '23px',
  boxSizing: "border-box",
  overflow: "hidden",
};

export default function CustomerDetailInfoSection({ customer }) {
  const leftFields = [
    { icon: EmailIcon, label: "Email", value: customer.email },
    { icon: PhoneIcon, label: "Phone", value: customer.phone },
    { icon: CompanyIcon, label: "Company", value: customer.company },
    { icon: LocationIcon, label: "Location", value: customer.location },
  ];

  const rightFields = [
    {
      icon: StatusIcon,
      label: "Status",
      valueNode: <StatusChip status={customer.status} />,
    },
    {
      icon: ConversationsIcon,
      label: "Conversations",
      value: String(customer.chats ?? 0),
    },
    { icon: TimezoneIcon, label: "Timezone", value: customer.timezone },
    { icon: LastSeenIcon, label: "Last seen", value: customer.lastSeen },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
        Information
      </Typography>
      <Box sx={sectionCardSx}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "minmax(0, 1fr) minmax(0, 1fr)" },
            columnGap: 3,
            rowGap: 3,
            minWidth: 0,
            alignItems: "start",
          }}
        >
          {leftFields.map((field, index) => (
            <Box
              key={field.label}
              sx={{
                minWidth: 0,
                overflow: "hidden",
                gridColumn: { sm: 1 },
                gridRow: { sm: index + 1 },
              }}
            >
              <CustomerDetailInfoField {...field} />
            </Box>
          ))}
          {rightFields.map((field, index) => (
            <Box
              key={field.label}
              sx={{
                minWidth: 0,
                overflow: "hidden",
                gridColumn: { sm: 2 },
                gridRow: { sm: index + 1 },
              }}
            >
              <CustomerDetailInfoField {...field} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
